import { translateLayer } from 'shared/stores/annotations/legacy-translations';
import { escapeDataServerAttributeValue } from 'uScope/js/lib/utility/helpers';
import { nonenumerable } from '../../../decorators/nonenumerable';

/*
* This is silly. The ANNOTATIONS store should be the only thing responsible for creating layers. This circumvents that
* idea entirely!
*/

const LAYER_TYPES = {
  AAFINPUT: 1,
  AAFINAL: 2,
  AAFRESULT: 3,
  MANUAL: 4
};

export class AnnotationsAdapter {
  @nonenumerable annotationsService = null;
  @nonenumerable macro = null;
  @nonenumerable annotationsProvider = null;
  @nonenumerable inputLayerName = '';
  @nonenumerable outputLayerName = '';
  @nonenumerable inputLayer = '';
  @nonenumerable outputLayer = '';

  constructor (annotationsService, macro, annotationsProvider) {
    this.protectedMacroName = escapeDataServerAttributeValue(macro.name);
    this.annotationsService = annotationsService;
    this.macro = macro;
    this.annotationsProvider = annotationsProvider;
    this.inputLayerName = `${this.protectedMacroName} Input`;
    this.outputLayerName = `${this.protectedMacroName} Output`;
  }

  async createMacroLayers (inputLayer, outputLayer) {
    const layerManager = this.annotationsService.layers;
    let legacyInputLayer;
    let legacyOutputLayer;
    const layersToSave = [];

    if (!inputLayer) {
      legacyInputLayer = layerManager.createAdd({
        Name: this.inputLayerName,
        Type: LAYER_TYPES.MANUAL // Note: the AafInput type is unused since any layer can be used as an input layer.
      });
      layersToSave.push(translateLayer(legacyInputLayer));
    }

    if (!outputLayer) {
      let inputLayerId;
      let lineColor;
      if (inputLayer) {
        inputLayerId = inputLayer.id;
        lineColor = inputLayer.lineColor;
      } else {
        inputLayerId = legacyInputLayer.get('Id');
        lineColor = legacyInputLayer.get('LineColor');
      }
      legacyOutputLayer = layerManager.createAdd({
        InputAnnotationId: inputLayerId,
        Name: this.outputLayerName,
        Type: LAYER_TYPES.AAFRESULT,
        LineColor: lineColor,
        MacroName: this.protectedMacroName,
        MacroId: this.macro.id,
        Incremental: this.macro.isIncremental
      });
      layersToSave.push(translateLayer(legacyOutputLayer));
    }

    if (layersToSave.length > 0) {
      const imageId = layersToSave[0].imageId;
      const result = await this.annotationsProvider.addLayers(imageId, layersToSave);
      const savedLayers = result.data;

      const newInputLayer = savedLayers.find(l => l.name === this.inputLayerName);
      const newOutputLayer = savedLayers.find(l => l.name === this.outputLayerName);
      if (newInputLayer) {
        layerManager.updateLayerId(legacyInputLayer, newInputLayer.id);
      }
      if (newOutputLayer) {
        // TODO: Propagate this change back to the store
        legacyOutputLayer.set('InputAnnotationId', newOutputLayer.inputAnnotationId);
        layerManager.updateLayerId(legacyOutputLayer, newOutputLayer.id);
      }
    }
  }
}

export function makeLegacyAnnotationsAdapter ({resources, get}) {
  const annotationsService = get('VIEWPORT').plugins('us:annotations:service');
  const annotationsProvider = resources.get('ANNOTATIONS');
  if (!annotationsService) {
    return;
  }

  const {selectedMacro} = get('IA_MACROS');

  return new AnnotationsAdapter(annotationsService, selectedMacro, annotationsProvider);
}



// WEBPACK FOOTER //
// ./src/shared/stores/image-analysis/annotations/AnnotationsAdapter.js